import { atom, selector } from "recoil";
import { savedDisplayOperationState } from "../hooks/useDisplayOperation";
import { getProperty } from "../utils/FPEUtils";

export const FLIGHTPLAN_LIST_PANEL = 'FLIGHTPLAN_LIST_PANEL';

/* コンテンツ「Flight plan」のチェック状態 */
//パネル側でmapContentsVisibleWithIDを直接参照するとマップ中心座標が狂う問題があるため、DispatcherでON/OFF状態をこのstateに移し替える
export const flightPlanContentsVisibleState = atom({
  key: 'flightPlanContentsVisibleState',
  default: false
});

export const flightPlanListViewVisibleState = atom({
  key: 'flightPlanListViewVisibleState',
  default: selector({
    key: 'flightPlanListViewVisibleStateSelector',
    get: ({get}) => {
      const value = getProperty(get(savedDisplayOperationState), `${FLIGHTPLAN_LIST_PANEL}.visible`);
      return value !== undefined ? value : true;
    }
  })
});

export const flightPlanListViewPositionState = atom({
  key: 'flightPlanListViewPositionState',
  default: selector({
    key: 'flightPlanListViewPositionStateSelector',
    get: ({get}) => {
      return getProperty(get(savedDisplayOperationState), `${FLIGHTPLAN_LIST_PANEL}.position`) || null;
    }
  })
});

export const flightPlanListViewSizeState = atom({
  key: 'flightPlanListViewSizeState',
  default: selector({
    key: 'flightPlanListViewSizeStateSelector',
    get: ({get}) => {
      return getProperty(get(savedDisplayOperationState), `${FLIGHTPLAN_LIST_PANEL}.size`) || null;
    }
  })
});
